import React, { useEffect } from 'react'
import { WidgetHeader } from '../shared/stickee-widget/WidgetHeader'
import { Widget } from '../shared/stickee-widget/Widget'
import { WidgetFooter } from '../shared/stickee-widget/WidgetFooter'
import { ReactComponent as Logo } from './mobile.svg'
import { useGetWhiteLabelColorQuery } from './white-labeling.api'
import { loadScriptOnce } from '../utils/scriptLoader'

export const MobileQuotes = props => {
  const queryParameters = new URLSearchParams(window.location.search)
  const whiteLabelClientId = queryParameters.get('utm_source')
  const getTypeFromPath = () => {
    const path = location.pathname
    if (path.startsWith('/mobile')) return 'mobile'
    if (path.startsWith('/broadband')) return 'broadband'
    return 'broadband' // default to broadband if no match
  }
  const { data: whiteLabelColor, isLoading } = useGetWhiteLabelColorQuery(
    {
      clientId: whiteLabelClientId,
      type: getTypeFromPath()
    },
    {
      skip: !whiteLabelClientId
    }
  )

  useEffect(() => {
    if (isLoading) {
      return
    }

    let observer = null

    const loadScript = async () => {
      try {
        await loadScriptOnce(
          'https://whitelabels.stickeemobiles.co.uk/js/loader.js',
          {
            async: true
          }
        )
      } catch (error) {
        console.error('Failed to load mobile whitelabels script:', error)
      }
    }

    if (whiteLabelColor?.styleConfig) {
      // Set up MutationObserver to watch for the custom element
      observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.tagName === 'WHITELABELS-MOBILES-SITE'
            ) {
              // Element found, modify its config immediately
              if (node.hasAttribute('config')) {
                try {
                  const originalConfig = JSON.parse(node.getAttribute('config'))

                  const modifiedConfig = {
                    ...originalConfig,
                    theme: {
                      ...originalConfig.theme,
                      primary_color: whiteLabelColor.styleConfig,
                      secondary_negative_color: whiteLabelColor.styleConfig
                    }
                  }

                  node.setAttribute('config', JSON.stringify(modifiedConfig))
                  console.log(
                    'Config modified successfully:',
                    modifiedConfig.theme
                  )
                } catch (e) {
                  console.error('Failed to modify config:', e)
                }
              }
            }
          })
        })
      })

      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true
      })
    }

    loadScript()

    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [whiteLabelColor, isLoading])

  return (
    <>
      <WidgetHeader logo={Logo} />
      <Widget widgetId="youtility-435" />
      <WidgetFooter />
    </>
  )
}
